import React from 'react';
import { BrowserRouter as Router, Switch, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageContext';
import Navbar from './componets/Navbar/Navbar';
import Home from './pages/Home';
import Eventos from './pages/Eventos';
import Videos from './pages/Videos';
import AboutMe from './pages/AboutMe';
import AdminApp from './admin/AdminApp';
import './App.css';

function AppLayout() {
  const { pathname } = useLocation();
  const isAdmin = pathname.toLowerCase().startsWith('/admin');

  return (
    <>
      {!isAdmin && <Navbar />}
      <Switch>
        <Route path='/admin' component={AdminApp} />
        <Route path='/' exact component={Home} />
        <Route path='/eventos' exact component={Eventos} />
        <Route path='/videos' exact component={Videos} />
        <Route path='/aboutme' exact component={AboutMe} />
      </Switch>
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <AppLayout />
      </Router>
    </LanguageProvider>
  );
}

export default App;
